import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RomaneioImpressaoEntregaPage } from '@/features/romaneio/page/impressao/entrega/RomaneioImpressaoEntregaPage';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.object({ idpk: StringToIdpkSchema });

export const Route = createFileRoute('/a/romaneio/impressao/entrega/$idpk')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const { idpk } = Route.useParams();

    return <RomaneioImpressaoEntregaPage idpk={idpk} />;
}
